import ContactReducer           from '../sections/Contact/ContactReducer';
import ConversationsListReducer from '../sections/ConversationsList/ConversationsListReducer';
import MessagesReducer          from '../sections/MessagesFeed/MessagesReducer';
import RecipientsReducer        from '../sections/Recipient/RecipientsReducer';
import CustomFieldsReducer      from '../sections/CustomFields/CustomFieldsReducer';
import NextConversationReducer  from '../sections/NextConversation/NextConversationReducer';
import TranslationsReducer      from '../sections/Translations/TranslationsReducer';
import LanguageReducer          from '../components/LanguageToggle/LanguageReducer';
import env                      from '../env';
import ActionTypes              from '../ActionTypes';
import thunk                    from 'redux-thunk';
import {
    createStore,
    applyMiddleware,
    combineReducers,
    compose
}                               from 'redux';

export const appReducer = combineReducers({
    contactStore: ContactReducer,
    messagesStore: MessagesReducer,
    conversationsListStore: ConversationsListReducer,
    recipientsStore: RecipientsReducer,
    customFieldsStore: CustomFieldsReducer,
    nextConversationStore: NextConversationReducer,
    translationsStore: TranslationsReducer,
    languageStore: LanguageReducer
});

function rootReducer (state, action) {
    if (action.type === ActionTypes.USER_LOGOUT) {
        return appReducer(undefined, action);
    }

    return appReducer(state, action);
}

export default () => createStore(
    rootReducer,
    compose(
      applyMiddleware(thunk),
      // start REDUX dev tools
      env.DEV_TOOLS && (window as any).__REDUX_DEVTOOLS_EXTENSION__ ? (window as any).__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
    )
);



// WEBPACK FOOTER //
// ./src/reducers/index.ts